import { useGetThemeColors } from "ChakraTheme";
import { Button, IButtonProps } from "components/Button";

interface IProps extends IButtonProps {}

const NavigationBarButton = ({ children, ...restProps }: IProps) => {
  const colors = useGetThemeColors();
  return (
    <Button
      //bez transition wrażenie utraty płynności
      transition="all 0.075s ease"
      backgroundColor="transparent"
      width="100%"
      h="auto"
      minH="70px"
      borderRadius="15px"
      color={colors.white}
      whiteSpace="normal"
      _hover={{
        border: `solid 2px ${colors.white}`,
      }}
      _active={{
        bg: colors.white,
        color: colors.black,
      }}
      {...restProps}
    >
      {children}
    </Button>
  );
};

export { NavigationBarButton };
